// config
import { ENV } from 'config';

const URL_MAPPER: WsMapper = {
  PROD: 'wss://service.upstox.com/portfolio-stream-feeder/v2',
  QA: 'wss://service.upstox.com/portfolio-stream-feeder/v2',
  UAT: 'wss://service-uat.upstox.com/portfolio-stream-feeder/v2',
};

export const URL = URL_MAPPER[ENV];
